import request from '@/libs/request'

// 猪场数据可视化
export function dataVisualizationApi (data = {}) {
  return request({
    url: `pigFarm/dataVisualization`,
    method: 'get',
    params: data
  })
}



